// extracted by mini-css-extract-plugin
export var displayNone = "_uc-6";
export var imgContainer = "_uc-2";
export var overflowHidden = "_uc-3";
export var productInfoCardButtonContainer = "_uc-5";
export var productTitleText = "_uc-4";
export var rightArrow = "_uc-1";
export var rightArrowContainer = "_uc-0";